import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "submit", "eye"]

  eyeToggle () {
    this.eyeTarget.classList.toggle("font-weight-bold")
    const password = this.passwordTarget
    if (password.getAttribute("type") == "password") {
      password.setAttribute("type", "text")
    } else {
      password.setAttribute("type", "password")
    }
  }

  checkPasswordConfirmation () {
    if ((this.passwordTarget.value !== "") && (this.passwordTarget.value !== this.confirmationTarget.value)) {
      this.confirmationTarget.classList.add("is-invalid")
      this.submitTarget.setAttribute("disabled", "true")
    } else {
      this.confirmationTarget.classList.remove("is-invalid")
      this.submitTarget.removeAttribute("disabled")
    }
  }
}
